<template>
<div>
    <div class="form-group">
    <label  for="categoria"><strong>Trasporto a mezzo</strong></label>
        <select @change="$emit('update',shipperId,$event)" :disabled="!props.isActive" :required="props.required"  class="form-control" v-model="shipperId">                        
            <option v-for="(item,index) in items" :value="item.shipperId" :key="index">
                {{item.shipper}}</option>                            
        </select> 
    </div>
</div>

</template>
<script>
import api                   from "@/api";

export default {
  props : ['props'] , 
  components: {},
  data() {
    return {

      shipperId              : 0,
      items                  : [],
      spinner                : false,
      
           
    };
  },


  watch: {
     
    
    
    },
  mounted: function() 
  {
      
  },
  created: function() 
  {
      this.getData()
  },
  methods: 
  { 
      
      
    async getData()
    {            
      let json   = {'sp'    : 'spShipperSelect'}
      await api.post(json).then(res => {
            if(res.status==200)
            {
                

                this.items       = res.data.recordsets[0]                
                this.shipperId = this.props.Id
                
            }
           else if(res.status==500)
           {
                console.log(res.data)

            } 
          else
            {
                console.log('Network Error.')                  
                 
            } 
      
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

    

    },
  
    
    
  
}

}
</script>
<style scoped>

</style>